<ion-list>
    <ion-item button (click)="dismiss('suggestions')" *ngIf="showSuggestion && !is_multiple">
        <ion-label>{{'Suggestions' | translation}}</ion-label>
        <ion-icon name="help-buoy" slot="start"></ion-icon>
    </ion-item>
    <ion-item button (click)="dismiss('documents')">
        <ion-label>{{'Documents' | translation}}</ion-label>
        <ion-icon name="images" slot="start"></ion-icon>
    </ion-item>
    <!-- <ion-item button (click)="dismiss('resources')">
        <ion-label>{{'Bible' | translation}}</ion-label>
        <i class="custom-bible-icon fa fa-bible" slot="start"></i>
    </ion-item> -->
    <ion-item button (click)="dismiss('templates')">
        <ion-label>{{'Templates' | translation}}</ion-label>
        <ion-icon name="clipboard" slot="start"></ion-icon>
    </ion-item>
    <ion-item button (click)="dismiss('links')">
        <ion-label>{{'HelpfulLinks' | translation}}</ion-label>
        <ion-icon name="link" slot="start"></ion-icon>
    </ion-item>
    <ion-item button (click)="dismiss('re-assign')" *ngIf="!is_multiple">
        <ion-label>{{'Reassign' | translation}}/{{'Close' | translation}}</ion-label>
        <ion-icon name="refresh" slot="start"></ion-icon>
    </ion-item>
</ion-list>
